export default function (situation) {
  return {
    type: 'setSituation',
    situation,
  };
}
